import { FlaskConical } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { AdvancedAnalyticsRoutes } from "./routePaths";
import { AdvancedAnalyticsPermissions } from "./permissions";

/**
 * "Analytics Advance" — self-service exploration module.
 * Grouped like Mixpanel: Explorar / Audiencias / Monitoreo / Datos & Governance.
 * (INavItem is flat; group headers are conveyed via labels/order.)
 */
const view = [AdvancedAnalyticsPermissions.VIEW];

export const advancedAnalyticsNav: INavItem = {
  labelKey: "nav.advanced_analytics",
  icon: FlaskConical,
  path: AdvancedAnalyticsRoutes.FUNNELS,
  permissions: view,
  permissionPrefix: "Travel:AdvancedAnalytics:",
  children: [
    { labelKey: "nav.adv_funnels", path: AdvancedAnalyticsRoutes.FUNNELS, permissions: view },
    { labelKey: "nav.adv_flows", path: AdvancedAnalyticsRoutes.FLOWS, permissions: view },
    { labelKey: "nav.adv_retention", path: AdvancedAnalyticsRoutes.RETENTION, permissions: view },
    { labelKey: "nav.adv_cohorts", path: AdvancedAnalyticsRoutes.COHORTS, permissions: view },
    { labelKey: "nav.adv_users", path: AdvancedAnalyticsRoutes.USERS, permissions: view },
    { labelKey: "nav.adv_boards", path: AdvancedAnalyticsRoutes.BOARDS, permissions: view },
    { labelKey: "nav.adv_reports", path: AdvancedAnalyticsRoutes.REPORTS, permissions: view },
    { labelKey: "nav.adv_alerts", path: AdvancedAnalyticsRoutes.ALERTS, permissions: view },
    { labelKey: "nav.adv_events", path: AdvancedAnalyticsRoutes.EVENTS, permissions: view },
    { labelKey: "nav.adv_dictionary", path: AdvancedAnalyticsRoutes.DICTIONARY, permissions: view },
    { labelKey: "nav.adv_governance", path: AdvancedAnalyticsRoutes.GOVERNANCE, permissions: view },
  ],
};
